// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1Xp6_","input":"Checkbox_input__29Z2Z","inner":"Checkbox_inner__vm--Z","tick":"Checkbox_tick__2zuu1","text":"Checkbox_text__2w2y-"};